import { render, staticRenderFns } from "./VideoAskTest.vue?vue&type=template&id=5ab648fc&"
import script from "./VideoAskTest.vue?vue&type=script&lang=js&"
export * from "./VideoAskTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports